//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { czHomePath } from '~/constant/cz';
export default {
  name: 'Breadcrumbs',
  data() {
    return {
      czHomePath,
    };
  },
  computed: {
    ...mapState({
      breadcrumbs: (state) => state.breadcrumbs,
    }),
  },
};
